import "@/index.css";
import "@/App.css";
import LandingPage from "./pages/LandingPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App font-body">
      <LandingPage />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
